module.exports = __webpack_public_path__ + "img/help-screen.82684b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/pages/index/assets/img/help-screen.jpg
// module id = 167
// module chunks = 0